<template>
  <div class="scans">
    <div class="upload-from-dialog">
      <a href="" @click.prevent="$refs.scan.click()" style="color: #0597F2" class="a-btn">Загрузить...</a>
    </div>
    <input
      type="file"
      ref="scan"
      @change="addFileFromDialog"
      style="display:none"
      multiple
    />

    <ScanCard
      v-for="scan of scansByDocument(this.documentId)"
      :key="scan.id"
      :scan="scan"
      @detail-scan="detailScan(scan)"
      @remove-scan="removeItem(scan.id)"
      @update-scan="updateScan"
      @upload-scan="uploadScan(scan)"
    />
    <LightBox v-if="showDetail" @close="showDetail = false" :scan="currentScan" />
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  name: 'ScansGallery',
  props: ['documentId'],
  data () {
    return {
      dragging: false,
      showDetail: false,
      currentScan: null
    }
  },
  computed: {
    ...mapGetters('taxi/scans', [
      'scansByDocument'
    ]),
    ...mapState('taxi/scans', [
      'currentModel'
    ])
  },
  methods: {
    detailScan (scan) {
      this.currentScan = scan
      this.showDetail = true
    },
    addFileFromDialog (e) {
      this.addFiles(e.target.files)
      this.$refs.scan.value = null
    },
    addFileFromDrop (e) {
      this.addFiles(e.dataTransfer.files)
    },
    addFiles (files) {
      const formData = new FormData()
      files.forEach(element => {
        formData.append('upfiles[]', element)
      })
      formData.append('model', this.currentModel)
      formData.append('id', this.documentId)
      this.dragging = false
      this.uploadItem(formData)
    },
    updateScan ({ scan }) {
      this.updateItem(scan)
    },
    ...mapActions('taxi/scans', [
      'uploadItem',
      'removeItem',
      'updateItem'
    ])
  }
}
</script>

<style scoped>
  .upload-from-dialog {
    float: right;
    position: relative;
    width: 100%;
    margin-bottom: .7rem;
    z-index: 10 !important;
  }
  .upload-from-dialog .a-btn {
    float: right;
    margin-bottom: .2rem;
    z-index: 2;
  }
  .drag-icon {
    opacity: 1 !important;
    z-index: 8 !important;
    color: #007bff !important;
  }
  .background {
    z-index: 1;
    position: absolute;
    font-size: 8rem;
    color: #007bff;
    opacity: 0.15;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .scans {
    min-height: 10rem;
  }
  .loader {
    z-index: 0;
    position: absolute;
    opacity: 0.15;
    width: 100%;
    height: 100%;
    left: 250px;
    right: 20px;
    top: 43px;
  }
  .drag {
    z-index: 9;
    opacity: 0.5;
    background-color: #f7f7f9;
    outline: 2px dashed #007bff;
    outline-offset: -20px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
  }
</style>
